export const facebookIcon = () => (
  <svg fill='none' height='24' width='24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.224 2h-2.71A4.655 4.655 0 0 0 9.5 6.922V9.19H6.773a.417.417 0 0 0-.426.408v3.288a.417.417 0 0 0 .426.408h2.725v8.3a.417.417 0 0 0 .426.408h3.555a.418.418 0 0 0 .426-.408V13.3h3.186a.418.418 0 0 0 .426-.408V9.6a.4.4 0 0 0-.125-.288.436.436 0 0 0-.3-.12H13.91V7.268c0-.925.23-1.394 1.49-1.394h1.824a.417.417 0 0 0 .426-.408V2.412A.417.417 0 0 0 17.224 2Z'
      fill='currentColor'
    />
  </svg>
);
